import PropTypes from 'prop-types'
import { useTheme } from '@emotion/react'

import { getChartColors, styles } from './utilities'

// Custom HTML legend for more control over placement + mobile support
export default function GraphLegend({
  dataset,
  desktopVertical,
  altLegend,
  colorsByIndex,
  ...rest
}) {
  const theme = useTheme()

  const legendValues = altLegend ? Object.keys(dataset[0]).slice(1) : dataset

  return (
    <div {...rest}>
      <ul
        className="GraphLegend__List"
        css={[
          {
            listStyle: 'none',
            padding: 0,
            display: 'flex',
            marginTop: -theme.space.base,
            marginLeft: -theme.space.base,
            flexWrap: 'wrap',
            justifyContent: 'center',
            fontSize: theme.fontSize.xsmall,
            position: 'relative',
            zIndex: 1, // So it sits above overlapping graph
            fontFamily: styles.font.mono,
          },

          desktopVertical && {
            [theme.mq.medium]: {
              marginTop: 0,
              marginLeft: 0,
              display: 'grid',
              gridTemplateColumns: '1fr',
              gap: theme.space.small,
              justifyContent: 'start',
            },
          },
        ]}
      >
        {legendValues.map((chunk, index) => (
          <li
            key={altLegend ? chunk : chunk.id}
            css={[
              {
                marginTop: theme.space.base,
                marginLeft: theme.space.base,
                display: 'grid',
                gridAutoFlow: 'column',
                gridAutoColumns: 'auto',
                justifyContent: 'start',
                alignItems: 'center',
                gap: theme.space.small,
              },

              desktopVertical && {
                [theme.mq.medium]: {
                  marginTop: 0,
                  marginLeft: 0,
                },
              },
            ]}
          >
            <div
              css={{
                width: theme.fontSize.base,
                height: theme.fontSize.base,
                borderRadius: '9999px',
              }}
              style={{
                background: getChartColors(colorsByIndex || dataset.length)[
                  index
                ],
              }}
            />
            {altLegend ? legendValues[index] : chunk.id}
          </li>
        ))}
      </ul>
    </div>
  )
}

GraphLegend.propTypes = {
  colorsByIndex: PropTypes.number,
  dataset: PropTypes.array.isRequired,
  // Vertical orientation on larger screens
  desktopVertical: PropTypes.bool,
  altLegend: PropTypes.bool,
}
